import "./form.js";
import "./helper.js";

// EVENT TYPES
// namespace:type:state
// Example: sp:remove_foo:complete

// VITE_MIGRATION: Replace window global with proper ES module export when admin JS is fully modularized
window.SP_EVENTS = {
  SLIDE_UP: {
    TYPE: "sp:slide_up",
    DEFAULT_DURATION: 300,
  },
  SLIDE_DOWN: {
    TYPE: "sp:slide_down",
    DEFAULT_DURATION: 300,
  },
};

// The functions below are named by server-rendered inline handlers (link_to_function,
// onchange, and `.js.erb` responses), which evaluate in global scope. This file is an ES
// module, so a bare declaration would be module-private and the handler would not resolve it.
window.removeWithChange = function removeWithChange(element) {
  element = jQuery(element);
  const parents = element.parents();
  element.remove();
  parents.trigger("change"); // Handlers may be watching for changes to content, so notify them of the removal
};

window.mark_for_destroy = function mark_for_destroy(element, klass) {
  const $el = jQuery(element);
  const $target = $el.closest(klass);
  const $targetParent = $target.parent();
  $el.hide(); // Hide the delete button so it can't be clicked multiple times, and also so it doesn't get clipped
  $el.siblings(".should_destroy").val(1);

  jQuery(document).trigger(SP_EVENTS.SLIDE_UP.TYPE, $targetParent);
  slide_back_element($target, function () {
    $target.hide();
  });
};

window.remove_with_slider = function remove_with_slider(element, klass) {
  const $el = jQuery(element);
  const $target = $el.closest(klass);
  const $targetParent = $target.parent();
  $el.hide(); // Hide the delete button so it can't be clicked multiple times, and also so it doesn't get clipped
  $target.attr("data-removing", "true"); // The node survives until the slide-up ends; readers must not treat it as live
  $target.find(":input").prop("disabled", true); // A disabled input never submits, so the lingering row cannot POST
  // :input reaches native controls only; hyphenated tags are custom-element hosts
  // that submit through ElementInternals, so disable them via their attribute.
  $target
    .find("*")
    .filter(function () {
      return this.tagName.includes("-");
    })
    .attr("disabled", "");
  jQuery(document).trigger(SP_EVENTS.SLIDE_UP.TYPE, $targetParent);
  slide_back_element($target, function () {
    $target.remove();
  });
};

function slide_back_element(element, callback) {
  jQuery(element).slideUp(SP_EVENTS.SLIDE_UP.DEFAULT_DURATION, callback);
}

window.focus_on = function focus_on(element) {
  jQuery("#" + element).addClass("focused");
  jQuery("#" + element).scrollTop();
};

window.set_positions_for = function set_positions_for(list) {
  const list_name = list + "_list";
  jQuery("#" + list_name)
    .find('[name*="list_position"]')
    .each(function (index) {
      jQuery(this).val(index + 1);
    });
};

window.toggle_section_context = function toggle_section_context(name) {
  const element = jQuery("#" + name);
  element.toggle(":visible");
};

// ====================
// = Sweetalert setup =
// ====================

var sweetAlertConfirmConfig = {
  title: "Are you sure?",
  type: "warning",
  showCancelButton: true,
  confirmButtonText: "Confirm",
  cancelButtonText: "Cancel",
};

// DOM READY
function installAdminBase() {
  function toggleSearch() {
    jQuery(".search").toggleClass("expanded");
  }

  jQuery(".icon-search").on("click", toggleSearch);

  function closeNavigationMenus() {
    document.querySelectorAll("sp-menu.admin-menu").forEach((menu) => menu.hide?.());
  }

  jQuery(".navigation-wrapper.compact").on("mouseleave", closeNavigationMenus);

  Form.decorate();
}

jQuery(installAdminBase);
